define(['components/modal', 
        'components/sidebar-flow',
        'core/urls', 
        'core/iterate',
        'components/pagination', 
        'components/search-field',
        'components/fake-progress',
        'components/request-time-manager',
        'components/dropdown',  
        'core/browser-storage',
        'core/utilities'
    ],
    function (
            modal, 
            sidebar, 
            urls, 
            iterate, 
            initPagination, 
            initSearchField, 
            FakeProgress, 
            requstTM, 
            DD, 
            browser_storage,
            utilities
    ) {
        var nodes = {
            resultWrap: document.querySelector(".import-contacts .table-results-wrap"),
            resultWrapUpload: document.querySelector(".upload-contacts .table-results-wrap"),
            loader: document.querySelector(".marketing-loader"),
            numContacts: document.querySelector(".num-contacts_js"),
            countDisplay: document.querySelectorAll(".contacts-selected .count"),
            sendBtn: document.querySelector(".send-btn_js"),
            editBtn: document.querySelector(".edit-btn_js"),
            addRecipientsWrap: document.querySelector(".add-recipients_js"),
            reviewContactsWrap: document.querySelector(".review-contacts-wrap"),
            selectLimit: document.querySelectorAll(".nps-responses-limit_js"),
            done: document.querySelector(".done-btn_js"),
            doneUpload: document.querySelector(".done-upload-btn_js"),
            contactsWrapper: document.querySelector(".nps-contacts"),
            importContactsContent: document.querySelector(".import-contacts"),
            importContactsBtn: document.querySelector(".import-contacts-btn"),
            uploadContactsBtn: document.querySelector(".upload-contacts-btn"),
            contactUpdatesWrap: document.querySelector(".contact-updates-wrap"),
            contactFilters: document.querySelector(".contact-filters"),
            searchField: {
                searchField: document.querySelector(".import-contacts .search-response_js"),
                resetBtn: document.querySelector(".import-contacts .search-response-reset_js"),
                openBtn: document.querySelector(".import-contacts .search-response-open_js"),
                wrap: document.querySelector(".import-contacts .results-search-wrap_js")
            },
            uploadSearchField: {
                searchField: document.querySelector(".upload-contacts .search-response_js"),
                resetBtn: document.querySelector(".upload-contacts .search-response-reset_js"),
                openBtn: document.querySelector(".upload-contacts .search-response-open_js"),
                wrap: document.querySelector(".upload-contacts .results-search-wrap_js")
            },
            importContactsPagination: {
                wrap: document.querySelector(".import-contacts .pagination_js"),
                page: document.querySelector(".import-contacts .pagination_page_js"),
                hole: document.querySelector(".import-contacts .pagination_hole_js")
            },
            uploadContactsPagination: {
                wrap: document.querySelector(".upload-contacts .pagination_js"),
                page: document.querySelector(".upload-contacts .pagination_page_js"),
                hole: document.querySelector(".upload-contacts .pagination_hole_js")
            },
            modal: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    // document.querySelector(".nps-s1-setup-campaign"),
                    // document.querySelector(".navigation-main"),
                    // document.querySelector(".navigation-top")
                ]
            },
            modalApiPermissions: document.querySelector(".modal-template-api-permissions_js"),
            modal500Error: document.querySelector(".modal-template-500-error_js"),
            modalMarketingGroupsError: document.querySelector(".modal-template-marketing-groups-error_js"),
            modalLeave: document.querySelector(".modal-template-leave_js"),
            modalRule: document.querySelector(".modal-template-rule_js"),
            confirmPermission: document.querySelector(".confirm-permissions_js"),
            sideBarStepsImport: {
                openBtn: document.querySelector(".import-contacts-btn"),
                wrap: document.querySelector(".import-sidebar_js"),
                closeSideBar: document.querySelector(".import-close-sidebar_js"),
                menuSteps: document.querySelectorAll(".import-sidebar-menu-step_js"),
                contentSteps: document.querySelectorAll(".import-sb-step_js")
            },
            sideBarStepsUpload: {
                openBtn: document.querySelector(".upload-contacts-btn"),
                wrap: document.querySelector(".upload-sidebar_js"),
                closeSideBar: document.querySelector(".upload-close-sidebar_js"),
                menuSteps: document.querySelectorAll(".upload-sidebar-menu-step_js"),
                contentSteps: document.querySelectorAll(".upload-sb-step_js")
            },
            uploadContactsForm: {
                fileStatus: document.querySelector(".file-messages .file-status .message"),
                spinner: document.querySelector(".spinner"),
                uploadForm: $(".upload-wrap form"),
                formMessage: document.querySelector(".file-messages .feedback"),
                statusIcon: document.querySelector(".file-messages .icon"),
                proceedButton:  document.querySelector("#uploadContactsProceed"),
            },
            confirmFilter: document.querySelector(".confirm-filter_js"),
            confirmUpload: document.querySelector(".confirm-upload_js"),
            goToUpdatePermissions: document.querySelector(".go-to-update-permissions_js"),
            maxMessage: {
                selector: "#max-message",
                node: null
            },
            addEmailButton: {
                selector: "#add-email",
                node: null
            }
        };

        let platform = nodes.contactsWrapper.getAttribute("data-platform");
        
        let campaignIsLocked = window.location.search.indexOf("campaign") > -1;

        const filters = {};
        let filterData = {};

        let contactLimitDD = 0;

        let waitTR = document.querySelectorAll(".wait-tr");
        waitTR.forEach(el => el.classList.add("disabled"));

        const params = {};
        let appliedFilters = {};

        if(platform === "cw") {
            params.is_primary = [];
            params.is_billing = [];
        }

        let requestData = {
            q: "",
            limit: 10,
            page: 1,
            page_info: {},
            sort: {
                company: "desc",
                first_name: "desc",
                last_name: "desc",
                title: "desc",
                company_location: "desc",
                types: "desc",
                company_status: "desc"
            }
        };


        let table = document.createElement('table');
        table.classList.add("contacts-table");
        let respBody = '';
        let tableColumns = {};
        let numberOfContacts = 0;
        let lastSort = {"company":"asc"};
        let intialProgressBar;
        let filtersTimeManager = new requstTM();
        let getFiltersProcess = false;
        let activeRule = 0;
        let flow = '';
        let reviewRecipientsStep = document.querySelector('[data-step="reviewRecipients,1"]');
        let resultNode = reviewRecipientsStep.querySelector(".result");
        let csvFileName = null;

        let loaderNode = nodes.loader.querySelector(".loader-bar-wrap-bar");
        intialProgressBar = new FakeProgress(loaderNode);

        // display first rendered sidebar in flow
        let firstSidebar = nodes.sideBarStepsImport.contentSteps[0].getAttribute("data-step"); // eg: "updatePermissions,1"
        firstSidebar = firstSidebar.split(",") // ["updatePermissions", "1"]

        let filterResponseStatus = 0;

        let getSelectedCount = (contactsStore) => {
            let count = 0;
            
            iterate(contactsStore, function (i) {
                if (i) {
                    count++;
                }
            });

            let countText = count === 1 ? "<strong>1 contact</strong> currently selected" : `<strong>${count} contacts</strong> currently selected`

            nodes.countDisplay.forEach(node => {
                node.innerHTML = countText;
            });

            return count;
        }

        function renderUsedFilters(node, csv) {
            // node will only be passed in after going through contacts import/upload
            // otherwise we use values present in the DOM during page load

            // add relevant post response data to DOM
            if(typeof node !== 'undefined') {
                let contactsWrap = document.querySelector(".contact-updates-wrap")

                let updatedCurrentFilters = node.getAttribute("data-current-filters");
                let updatedExcludedContacts = node.getAttribute("data-excluded-contacts");
                
                contactsWrap.setAttribute("data-current-filters", updatedCurrentFilters)
                contactsWrap.setAttribute("data-excluded-contacts", updatedExcludedContacts);

                document.querySelector(".contacts-warning").classList.remove("disabled");
            }

            let dataNode = typeof node === 'undefined' ? document.querySelector(".contact-updates-wrap") : node;
            let filtersWrap = document.querySelector(".filters-wrap");
            let usedFilters = JSON.parse(dataNode.getAttribute("data-used-filters") || "{}");
            let currentFilters = JSON.parse(dataNode.getAttribute("data-current-filters") || "{}");

            let filtersNode = document.querySelector(".filters-used");
            let sourceNode = document.querySelector(".contact-source");

            let source;

            if(!node) {
                // csv (optional) and platform will be present on page load
                source = dataNode.getAttribute("data-csv-name") ? dataNode.getAttribute("data-csv-name") : dataNode.getAttribute("data-platform")
            } else {
                // if csv is passed in on contacts update, use that - otherwise show user's platform
                source = csv ? csv : dataNode.getAttribute("data-platform");
            }

            sourceNode.innerHTML = source;

            if (dataNode.getAttribute("data-csv-name").trim().length || (csv && csv.length)) {
                filtersWrap.classList.add("hide");
            } else {
                filtersWrap.classList.remove("hide");
            }

            // clear csvFileName until next time a CSV is uploaded
            csvFileName = '';

            // used filters are previously saved filters
            // current filters are the most recently selected filters
            // always show the most recent selection if
            let filtersToDisplay = Object.keys(currentFilters).length ? currentFilters : usedFilters;
            let hasFilter = false;
            let categories = filtersToDisplay ? Object.keys(filtersToDisplay) : [];
            let renderedFilters = '';

            let renderedCategoriesAndFilters = categories.map(category => {
                if (filtersToDisplay[category] === true) {
                    document.querySelector(`input[data-field='${category}']`).checked = true;
                    appliedFilters[category] = ["Yes"];
                    params[category] = true;
                    hasFilter = true;
                    renderedFilters = ["<div>Yes</div>"];
                } else {
                    if(!Array.isArray(filtersToDisplay[category]) || !filtersToDisplay[category].length) return;

                    renderedFilters = filtersToDisplay[category].map(filter => {
                        let output = typeof filter === "object" ? filter.name : filter;
                        return `<div>${output}</div> `;
                    })
                    hasFilter = true;
                }

                let output = `
                    <span class="category-wrap">
                        <span class="category">${category.replace("_", " ")}:</span>
                        <span class="filters">${renderedFilters.join('')}</span>
                    </span>
                `;

                return output;
            });

            if(hasFilter) {
                filtersNode.innerHTML = renderedCategoriesAndFilters.join('');
            } else {
                filtersNode.innerHTML = `<span class="category-wrap">
                        <span class="filters"><div>None</div></span></span>`;
            }
        }

        renderUsedFilters();

        function requestFilters() {

            if (getFiltersProcess) {
                filtersTimeManager.abort({success: true});
            }

            let hint = nodes.loader.querySelector(".loader-bar-wrap_hint");

            hint.innerText = "Please wait while we load your available filters."

            if(platform === "cw") {
                hint.innerText = `Depending on the configuration of your ConnectWise PSA instance and data volume, loading filters can take up to 5 minutes.`;
            }

            if(flow === "upload") {
                return;
            }

            return new Promise((res, rej) => {
                filtersTimeManager.start( () => {
                    createdModal.open(null, function (el) {

                        el.querySelector(".error-confirm_js").addEventListener("click", () => {
                            createdModal.close();
                            importContactsSideBar.close();
                        });

                    }, nodes.modalApiPermissions);

                    rej();

                });

                let request = () => {
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', urls['nps:initial-tss-filters'](), true);
                    filtersTimeManager.addXHR(xhr); //FIXME Should be placed after xhr.open to work in IE 11
                    xhr.send();

                    xhr.onload = function () {
                        filterResponseStatus = xhr.status;
                        if (xhr.status != 200) {
                            getFiltersProcess = false;
                            filtersTimeManager.abort();
                            rej();
                        } else {
                            var resp = JSON.parse(xhr.responseText);
                            if (!resp.filters_loaded && !getFiltersProcess) {
                                intialProgressBar.startLoading(resp.requests_count);
                                getFiltersProcess = true;
                            }

                            if (!resp.success) {
                                getFiltersProcess = false;
                                filtersTimeManager.abort();
                                rej();
                            }

                            if (resp.filters_loaded) {
                                filtersTimeManager.abort({success:true});
                                intialProgressBar.loadFinish();
                                res(resp);
                            };
                        }
                    };
                };
                filtersTimeManager.interval(request);
            });

        }

        let getContactsProcess = false;
        let contactsTimeManager = new requstTM();
        let lastXHR = false;

        function getContacts (params, first) {
            let hint = intialProgressBar.wrap.parentNode.querySelector(".loader-bar-wrap_hint");
            let contactsProgressNode = document.querySelector(".import-contacts .loader-bar-wrap_contacts");
            let contactsProgress = new FakeProgress( contactsProgressNode.querySelector(".import-contacts .loader-bar-wrap-bar") );
            let resultWrapper = nodes.resultWrap;

            hint.innerText = "Please wait while we load your available contacts."

            if(platform === "cw" && flow !== "upload") {
                hint.innerText = `Depending on the configuration of your ConnectWise PSA instance and data volume, loading contacts can take up to 2 minutes.`;
            }

            if(flow === 'upload') {
                contactsProgressNode = document.querySelector(".upload-contacts .loader-bar-wrap_contacts");
                contactsProgress = new FakeProgress( contactsProgressNode.querySelector(".upload-contacts .loader-bar-wrap-bar") );
                resultWrapper = nodes.resultWrapUpload;
                resetTable();
            }

            if (getContactsProcess) {
                contactsTimeManager.abort({success: true});
            }

            if (lastXHR) {
                lastXHR.abort();
                lastXHR = false;
                contactsTimeManager.abort({success: true});
            }

            waitTR.forEach(el => el.classList.remove("disabled"));

            ( document.querySelector(".no-contacts-message") || {} ).innerHTML = "";

            contactsProgressNode.classList.add("active");

            resultWrapper.classList.add("loading");

            return new Promise((res, rej) => {

                contactsTimeManager.start(() => {
                    
                    if(!createdModal.isOpen) {
                        createdModal.open(null, function (el) {

                            el.querySelector(".error-confirm_js").addEventListener("click", () => {
                                createdModal.close();
                                importContactsSideBar.close();
                            });
    
                        }, nodes.modalApiPermissions);
                    }

                    nodes.loader.classList.add("disabled");
                    intialProgressBar.loadFinish();
                    lastXHR = false;
                    getContactsProcess = false;
                    rej();

                });

                delete params.page_info;

                contactsProgress.reset();

                let request = () => {

                    var xhr = new XMLHttpRequest();
                    let url = "?data=" + encodeURIComponent(JSON.stringify(params));
                    xhr.open('GET', urls['nps:tss-contacts']() + url, true);
                    contactsTimeManager.addXHR(xhr);
                    xhr.setRequestHeader("Content-Type", "application/json");

                    if (!lastXHR || lastXHR.status !== 0) {
                        lastXHR = xhr;
                        xhr.send();
                    } else {
                        return;
                    }

                    xhr.onload = function () {

                        try {
                            var resp = JSON.parse(xhr.responseText);
                        } catch(e) {
                            var resp = JSON.parse("{}");
                        }

                        if (!getContactsProcess) {

                            if (first)
                                intialProgressBar.startLoading(resp.requests_count);
                            else {
                                contactsProgress.startLoading(resp.requests_count);
                            }
                            getContactsProcess = true;

                        }

                        if (xhr.status != 200) {
                            
                            createdModal.open(null, function (el) {
                                el.querySelector(".error-confirm_js").addEventListener("click", () => {
                                    createdModal.close();
                                });
                            }, nodes.modal500Error);

                            getContactsProcess = false;
                            lastXHR = false;
                            console.log("status !200 abort");
                            contactsTimeManager.abort();
                            rej();

                        } else if (resp.success) {

                            contactsProgress.loadFinish();
                            contactsProgressNode.classList.remove("active");

                            waitTR.forEach(el => el.classList.add("disabled"));
                            resultWrapper.classList.remove("loading");
                            getContactsProcess = false;
                            lastXHR = false;
                            contactsTimeManager.abort({success:true});
                            res(resp);

                        }

                    };
                };

                contactsTimeManager.interval(request);

            });

        }

        let closeModal = () => {
            importContactsSideBar.close();

            if(uploadContactsSideBar) {
                uploadContactsSideBar.close();
                document.querySelector(".file-messages .feedback").innerText = '';
            }

            removeExitImportContactsPrompt();
            createdModal.close();
        };

        confirmExitClickEvent = (event, flow) => {
            event.preventDefault();
            let modalTemplate = document.querySelector(".modal-template-leave_js");
            if(flow === 'upload') {
                modalTemplate.querySelector(".confirm-msg_js b").innerText = "Exit ‘Upload contacts’?";
            } else {
                modalTemplate.querySelector(".confirm-msg_js b").innerText = "Exit ‘Import contacts’?";
            }
            createdModal.open(null, function (el) {
                const a = el.querySelector("a");
                a.setAttribute("href", "#");
                a.removeEventListener("click",closeModal);
                a.addEventListener("click",closeModal);
            }, modalTemplate);
        }

        nodes.sideBarStepsImport.closeSideBar.addEventListener("click", event => {
            confirmExitClickEvent(event);
        });

        if (nodes.sideBarStepsUpload.openBtn) {

            nodes.sideBarStepsUpload.closeSideBar.addEventListener("click", event => {
                confirmExitClickEvent(event, 'upload')
            });

            var uploadContactsSideBar = sidebar
            .create(nodes.sideBarStepsUpload, [nodes.sideBarStepsUpload.openBtn]);

            var uploadContactsPagination = initPagination(nodes.uploadContactsPagination, function (value) {
                paginationCallback(value)
            });
        }

        const importContactsSideBar = sidebar
            .create(nodes.sideBarStepsImport, [nodes.sideBarStepsImport.openBtn]);


        let paginationCallback = (value) => {
            requestData.page = value;
            getContacts({...params, ...requestData, sort: lastSort}).then(renderContacts);
            window.scrollTo(0,0);
        }

        const importContactsPagination = initPagination(nodes.importContactsPagination, function (value) {
            paginationCallback(value)
        });

        importContactsSideBar.switch(firstSidebar[0], firstSidebar[1]);

        const createdModal = modal.create(nodes.modal);

        let arrowHtml = '<img class="select-arrow-icon" src="/static/icons/down.svg" alt="">';

        /* 
            The `tableColumns` config is used to define the output of table headers and 
            <td> tags for each supported platform:

            key: unique key for each data record
            text: text to display in table header
            header_classes: any CSS classes needed for each header
            td_classes: any CSS classes needed for each <td> in a column
        */

        function createResponseTable() {
            tableColumns = {
                zd: [
                    {
                        key: "company",
                        text: `Company ${arrowHtml}<br><span class="small">(Organization)</span>`,
                        header_classes: "sortable active"
                    },{
                        key: "full_name",
                        text: `Full Name ${arrowHtml}`,
                        header_classes: "sortable"
                    },{
                        key: "location",
                        text: `Location ${arrowHtml}<br><span class="small">(Time Zone)</span>`,
                        header_classes: "sortable"
                    },{
                        key: "role",
                        text: "Role",
                        header_classes: null,
                    }
                ],
                cw: [
                    {
                        key: "company",
                        text: `Company ${arrowHtml}`,
                        header_classes: "sortable active"
                    },{
                        key: "first_name",
                        text: `First ${arrowHtml}</br>Name`,
                        header_classes: "sortable"
                    },{
                        key: "last_name",
                        text: `Last  ${arrowHtml}</br>Name`,
                        header_classes: "sortable"
                    },{
                        key: "title",
                        text: `Contact ${arrowHtml}</br>Title`,
                        header_classes: "sortable"
                    },{
                        key: "types",
                        text: `Contact ${arrowHtml}</br>Type`,
                        header_classes: "sortable"
                    },{
                        key: "company_types",
                        text: `Company ${arrowHtml}</br>Type`,
                        header_classes: "sortable"
                    },{
                        key: "company_status",
                        text: `Company ${arrowHtml}</br>Status`,
                        header_classes: "sortable"
                    },{
                        key: "company_location",
                        text: `Company ${arrowHtml}</br>Location`,
                        header_classes: "sortable"
                    },{
                        key: "is_primary",
                        text: `Primary Contact ${arrowHtml}`,
                        header_classes: "sortable"
                    },{
                        key: "is_billing",
                        text: `Billing Contact ${arrowHtml}`,
                        header_classes: "sortable"
                    },{
                        key: "territory",
                        text: `Territory ${arrowHtml}`,
                        header_classes: "sortable"
                    },{
                        key: "agreement_type",
                        text: `Agreement Type ${arrowHtml}`,
                        header_classes: "sortable"
                    }
                ],
                fd: [
                    {
                        key: "company",
                        text: `Company ${arrowHtml}`,
                        header_classes: "sortable active"
                    },{
                        key: "full_name",
                        text: `Full Name ${arrowHtml}`,
                        header_classes: "sortable"
                    },{
                        key: "location",
                        text: `Location ${arrowHtml}<br><span class="small">(Time Zone)</span>`,
                        header_classes: "sortable"
                    },{
                        key: "title",
                        text: `Contact Title ${arrowHtml}`,
                        header_classes: "sortable"
                    }
                ],
                ks: [
                    {
                        key: "company",
                        text: `Company ${arrowHtml}<br><span class="small">(Account)</span>`,
                        header_classes: "sortable active"
                    },{
                        key: "first_name",
                        text: `First ${arrowHtml}</br>Name`,
                        header_classes: "sortable"
                    },{
                        key: "last_name",
                        text: `Last  ${arrowHtml}</br>Name`,
                        header_classes: "sortable"
                    },{
                        key: "location",
                        text: `Location ${arrowHtml}`,
                        header_classes: "sortable"
                    },{
                        key: "title",
                        text: `Contact Title ${arrowHtml}`,
                        header_classes: "sortable"
                    }
                ],
                at: [
                    {
                        key: "company",
                        text: `Company ${arrowHtml}`,
                        header_classes: "sortable active"
                    },{
                        key: "first_name",
                        text: `First ${arrowHtml}</br>Name`,
                        header_classes: "sortable"
                    },{
                        key: "last_name",
                        text: `Last  ${arrowHtml}</br>Name`,
                        header_classes: "sortable"
                    },{
                        key: "title",
                        text: `Contact Title ${arrowHtml}`,
                        header_classes: "sortable"
                    }
                ],
                hl: [
                    {
                        key: "company",
                        text: `Company ${arrowHtml}`,
                        header_classes: "sortable active"
                    },{
                        key: "first_name",
                        text: `First Name ${arrowHtml}`,
                        header_classes: "sortable"
                    },{
                        key: "last_name",
                        text: `Last Name ${arrowHtml}`,
                        header_classes: "sortable"
                    }
                ],
                'csv-random': [ // random CSV
                    {
                        key: "company",
                        text: `Company ${arrowHtml}`,
                        header_classes: "sortable active"
                    },{
                        key: "first_name",
                        text: `First ${arrowHtml}</br>Name`,
                        header_classes: "sortable"
                    },{
                        key: "last_name",
                        text: `Last  ${arrowHtml}</br>Name`,
                        header_classes: "sortable"
                    },{
                        key: "title",
                        text: `Contact ${arrowHtml}</br>Title`,
                        header_classes: "sortable"
                    },{
                        key: "location",
                        text: `Company ${arrowHtml}</br>Location`,
                        header_classes: "sortable"
                    }
                ],
            }

            let renderedTableHeaders = tableColumns[platform].map((header, i) => {
                return `<td 
                            ${header.header_classes ? `class="${header.header_classes}"` : ''}
                            ${header.key ? `data-id="${header.key}"` : ''}
                        >${header.text}</td>`;
            }).join('');

            const tableHtml = `
                <thead>
                    <tr>
                        <td>
                            <label class="checkbox-wrap">
                                <input class="checkbox-wrap__checkbox" type="checkbox" checked>
                                <div class="checkbox-wrap__checker"></div>
                            </label>
                        </td>
                        ${renderedTableHeaders}
                    </tr>
                </thead><tbody></tbody>`;

            table.innerHTML = tableHtml;

            respBody = table.querySelector("tbody");

            table.querySelector("thead tr").addEventListener("click", (e) => {

                let el = e.target;
                let key = el.getAttribute("data-id");

                if (key && el.classList.contains("sortable")) {

                    // let activeId = (table.querySelector("thead tr.active") || {getAttribute:i=>0}).getAttribute("data-id");

                    let isDesc = el.classList.contains("desc");
                    let isAsc = el.classList.contains("asc");
                    let sort = {};
                    let newType = "asc";

                    if ( isDesc || isAsc )  {

                        newType = isAsc ? "desc" : "asc";

                    } else {

                        newType = "asc";

                    }

                    sort = {[key]: newType};

                    getContacts({...params, ...requestData, sort}).then(function (resp) {

                        iterate( requestData.sort, (item, key) => {

                            requestData.sort[key] = "";

                        } );

                        iterate( document.querySelectorAll(".sortable"), (node) => {

                            node.classList.remove("asc");
                            node.classList.remove("desc");
                            node.classList.remove("active");

                        } );

                        if (newType === "asc") {

                            el.classList.remove("desc");
                            el.classList.add("asc");

                        } else {

                            el.classList.remove("asc");
                            el.classList.add("desc");
                        }

                        requestData.sort[key] = newType;
                        lastSort = sort;

                        el.classList.add("active");
                        renderContacts(resp);

                    });
                }
            });

            table.querySelector("thead input").addEventListener("click", () => {

                let input = table.querySelector("thead input");
                let checked = input.checked;

                let contactsStore = JSON.parse(localStorage.getItem("nps-contacts-session-storage"));

                iterate(contactsStore, function (i, key) {
                    contactsStore[key] = checked;
                });

                iterate(table.querySelectorAll("tbody input"), node => {

                    node.checked = checked;
                    const tr = node.parentNode.parentNode.parentNode;

                    if (checked) {

                        tr.classList.remove("disabled");

                    } else {

                        tr.classList.add("disabled");

                    }

                });

                let selectedCount = getSelectedCount(contactsStore);

                if (selectedCount === numberOfContacts) {

                    nodes.done.classList.remove("disabled");

                } else if (selectedCount !== 0) {

                    nodes.done.classList.remove("disabled");

                } else {

                    nodes.done.classList.add("disabled");

                }

                localStorage.setItem("nps-contacts-session-storage", JSON.stringify(contactsStore));

            });

            reviewRecipientsStep = flow === "upload" ? document.querySelector('[data-step="reviewUploadRecipients,1"]') : document.querySelector('[data-step="reviewRecipients,1"]');

            resultNode = reviewRecipientsStep.querySelector(".result");

            resultNode.appendChild(table);
        }

        function renderContacts(result) {

            if (result.error) {
                console.error("error");
            }

            requestData.page_info = result.page_info;
            requestData.page_info.count = result.page_info.available_ids.length;

            const contacts = result.contacts && result.contacts.length ? result.contacts : [
                // {
                //     id: 0,
                //     company: "innoteka",
                //     last_name: "Rohalskyi",
                //     first_name: "Oleh",
                //     company_status: "active",
                //     title: "hello world!!!",
                //     company_location: "Ukraine",
                //     company_type: "super",
                //     types: ["test1","test2","test3"],
                // }
            ];

            if (flow === "upload") {
                uploadContactsPagination.set(requestData.page_info);

            } else {
                importContactsPagination.set(requestData.page_info);
            }

            function onClick() {

                let input = this.querySelector("input");
                let contactsStore = JSON.parse(localStorage.getItem("nps-contacts-session-storage"));
                let ident = input.getAttribute("data-id") * 1;

                if (input.checked) {

                    input.checked = false;
                    contactsStore[ident] = false;
                    this.classList.add("disabled");

                } else {

                    input.checked = true;
                    contactsStore[ident] = true;
                    this.classList.remove("disabled");

                }

                let selectedCount = getSelectedCount(contactsStore);

                if (selectedCount === numberOfContacts) {

                    checker.checked = true;
                    nodes.done.classList.remove("disabled");

                } else if (selectedCount !== 0) {

                    checker.checked = false;
                    nodes.done.classList.remove("disabled");

                } else {
                    nodes.done.classList.add("disabled");
                }

                localStorage.setItem("nps-contacts-session-storage", JSON.stringify(contactsStore));

            }

            let contactsStore = JSON.parse(localStorage.getItem("nps-contacts-session-storage"));

            let tbody = respBody;
            tbody.innerHTML = "";
            iterate( contacts, function (item) {

                let tr = document.createElement("tr");
                tr.classList.add("contacts-table__row");
                let checked = contactsStore[item.id];

                let html = ``;

                html += `<td>
                            <label class="checkbox-wrap">
                                <input class="checkbox-wrap__checkbox" data-id="${item.id}" type="checkbox" ${checked ? "checked" : ""} />
                                <div class="checkbox-wrap__checker"></div>
                            </label>
                         </td>`;

                // populate each table item by looping through tableColumns config for current user's platform
                // merge any arrays and added applicable classes to <td>
                html += tableColumns[platform].map(column => {
                    let output = '-'
                    // is array
                    if(item[column.key] && typeof(item[column.key]) === "object" && item[column.key].length)
                        output = item[column.key].join("</br>")
                    // is string or boolean
                    else if(item[column.key] !== '') {
                        if(column.key === "full_name" && item["first_name"] && item["last_name"]) {
                            // combine first and last name if "full name" is expected
                            output = `${item["first_name"]} ${item["last_name"]}`;
                        } else if (column.key === "is_primary" || column.key === "is_billing") {
                            output = item[column.key] === true ? "Yes" : "–";
                        } else {
                            output = item[column.key] ? item[column.key].toString() : "-";
                        }                        
                    }

                    let classes = column.td_classes ? `class="${column.td_classes}"` : '';
                    
                    return `<td ${classes}>${output}</td>`;
                }).join('');

                tr.innerHTML = html;

                if (!checked) {
                    tr.classList.add("disabled")
                }

                tr.addEventListener("click", onClick.bind(tr));

                tbody.appendChild(tr);

            });

            let checker = table.querySelector("thead input");

            let selectedCount = getSelectedCount(contactsStore);
            let all = requestData.page_info.count;

            if (selectedCount === numberOfContacts) {
                checker.checked = true;
                nodes.done.classList.remove("disabled");
            } else if (selectedCount !== 0) {
                checker.checked = false;
                nodes.done.classList.remove("disabled");
            } else {
                nodes.done.classList.add("disabled");
            }

            if (numberOfContacts === 0) {
                checker.setAttribute("disabled", "disabled");
            }

            let oldResult = document.querySelector(".no-contacts-message");

            if (oldResult) {
                    oldResult.remove();
                }

            if (all === 0 ) {
                let messageNode = document.createElement("div");
                messageNode.classList.add("no-contacts-message");
                messageNode.innerText = "Your search didn't produce any results. Please expand your criteria and try again.";
                resultNode.appendChild(messageNode);

                if(params.marketing_groups && params.marketing_groups.length) {
                    createdModal.open(null, (el) => {
                        el.querySelector(".got-it_js").addEventListener("click", () => {
                            createdModal.close();
                        });
                    }, nodes.modalMarketingGroupsError);
                }
            } else {
                checker.removeAttribute("disabled");
            }
        }

        function sendContacts(params) {
            let csrfToken = document.querySelector("[name='csrfmiddlewaretoken']").value;
            
            return new Promise(function (res, rej) {
                let xhr = new XMLHttpRequest();
                xhr.open('POST', urls['nps:survey'](), true);
                xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                xhr.setRequestHeader("X-CSRFToken", csrfToken)
                xhr.send( JSON.stringify(params) );

                xhr.onload = function () {

                    if (xhr.status != 200) {

                        rej();

                    } else {

                        let resp = xhr.responseText;
                        res(resp);

                    }

                };

            });

        }

        function resetTable() {
            ddElement = flow === "upload" ? document.querySelector("#uploadContactsLimit") : document.querySelector("#importContactsLimit");

            lastSort = {"company": "asc"};

            DD(ddElement, (value) => {
                requestData.limit = value * 1;
                requestData.page = 1;
                getContacts({...params, ...requestData, sort: lastSort}).then(renderContacts);
            }).reset();

            requestData.q = "";
            requestData.limit = 10;
            requestData.page = 1;

            document.querySelector(".contacts-table .sortable.active")?.classList.remove("active");
            document.querySelector(".contacts-table .sortable")?.classList.add("active");

            nodes.selectLimit.forEach(el => {
                iterate(el.querySelectorAll("option"), function (node, key) {
                    if (key === 0) {
                        node.setAttribute("selected", "selected");
                    } else {
                        node.setAttribute("selected", "");
                    }
                })
            });

            nodes.selectLimit.forEach(el => el.value = 10);
            nodes.searchField.searchField.value = "";
        }

        nodes.sendBtn.addEventListener("click", (event) => {
            if(campaignIsLocked) {
                $.ajax({
                    url: urls['nps:finish']()
                }).done(function(response) {
                    browser_storage.setItem("campaign-saved", true);
                    window.location.replace(urls['nps:campaigns']());
                });
            } else {
                event.target.parentNode.submit();
            }
        })

        submitCampaign = () => {
            let params = {};
            params.contacts = JSON.parse(localStorage.getItem("nps-contacts-session-storage"));
            let filteredParams = [];

            iterate(params.contacts, function (item, key) {
                if (item) {
                    filteredParams.push(key);
                }
            });

            params.contacts = filteredParams;
            params.csrfmiddlewaretoken = document.querySelector("input[name='csrfmiddlewaretoken']").value;

            sendContacts(params).then((response) => {             
                nodes.addRecipientsWrap.classList.add("disabled");
                nodes.reviewContactsWrap.classList.remove("disabled");   
                
                nodes.numContacts.innerText = params.contacts.length;
                renderUsedFilters($(response).find(".contact-updates-wrap")[0], csvFileName);

                window.scrollTo(0,0);

                importContactsSideBar.close();
                if(uploadContactsSideBar)
                    uploadContactsSideBar.close();

            });            
        }

        function start(filters) {
            let intialSteps = () => {
                requestData = {
                    q: "",
                    limit: 10,
                    page: 1,
                    page_info: {},
                    sort: {
                        company: "desc",
                        first_name: "desc",
                        last_name: "desc",
                        title: "desc",
                        company_location: "desc",
                        types: "desc"
                    }
                };

                nodes.loader.classList.remove("disabled");

                intialProgressBar.reset();

                onGetContacts(function (res) {
                    resetTable();
                    intialProgressBar.loadFinish();

                    setTimeout(()=>{

                        intialProgressBar.reset();
                        nodes.loader.classList.add("disabled");

                        if(flow !== 'upload') {
                            setTimeout(()=>{
                                importContactsSideBar.switch("reviewRecipients", 1);
                            },200)
                        }
                    },500);

                },filters);
            };


            nodes.confirmFilter.addEventListener("click", () => {
                platform = nodes.contactsWrapper.getAttribute("data-platform");
                intialSteps()
            });

            if(flow === "upload") {
                intialSteps()
            };

            nodes.done.addEventListener("click", () => {
                submitCampaign();
                setTimeout(() => {
                    importContactsSideBar.switch(firstSidebar[0], firstSidebar[1]);
                }, 2000)
            });

            if(nodes.goToUpdatePermissions) {
                nodes.goToUpdatePermissions.addEventListener("click", () => {
                    importContactsSideBar.switch("updatePermissions", 1);
                })
            };

            function onGetContacts(cb) {
                let appliedFiltersWrapper = document.querySelector(".applied-filters-wrap");
                appliedFiltersWrapper.classList.add("hide");
                appliedFiltersWrapper.innerHTML = `<div class="applied-filters-title">Applied filters:</div>`;

                iterate(appliedFilters, function (item, key) {
                    if(!item.length) return;

                    appliedFiltersWrapper.classList.remove("hide");

                    let chips = item.map(i => {
                        return `<div class="chip">${i}</div>`;
                    });

                    let filterSection = `
                        <div class="filter-section">
                            <span class="filter-section-title">${filterNameMapping[key].singular}:</span>
                            <div class="applied-filters">
                                ${chips.join('')}
                            </div>
                        </div>
                    `;

                    appliedFiltersWrapper.insertAdjacentHTML("beforeend", filterSection);
                });

                params.sort = {"company":"asc"};
                getContacts(params,true).then((result) => {

                    // deselect any previously excluded contacts
                    let previouslyExcludedContacts = document.querySelector(".contact-updates-wrap").getAttribute("data-excluded-contacts");            
                    previouslyExcludedContacts = previouslyExcludedContacts ? JSON.parse(previouslyExcludedContacts) : [];

                    let contactsStore = {};
                    numberOfContacts = result.page_info.available_ids.length;

                    result.page_info.count = numberOfContacts;
                    result.page_info.available_ids.forEach( (i) => {
                        
                        contactsStore[i] = (previouslyExcludedContacts.includes(i) && window.filtersChanged === false) ? false : true;

                    });

                    localStorage.setItem("nps-contacts-session-storage", JSON.stringify(contactsStore));

                    renderContacts(result);

                    if (cb) cb();

                });

            }
        }

        let hrefs = document.querySelectorAll("a[href]");
        let message = "Exit ‘Import contacts’?";
        let exitModalTemplate = document.querySelector(".modal-template-leave_js");

        let hrefsToIgnore = [
            urls['nps:campaign'](), 
            urls['nps:configure-email'](), 
            urls['nps:configure-feedback'](), 
            urls['nps:survey']()
        ] 

        let exitGenericListener = function(event)  {
            message = "Exit ‘Create Campaign’?";
            if (exitModalTemplate.getAttribute("data-update-flow") !== "None")
                message = "Exit ‘Manage Campaign’?";
            utilities.confirmPageExit(event, createdModal, exitModalTemplate, message, hrefsToIgnore);

        };

        let exitImportContactsListener = function(event)  {
            message = "Exit ‘Import contacts’?";
            utilities.confirmPageExit(event, createdModal, exitModalTemplate, message, hrefsToIgnore);
        };


        function onExitGeneric() {
            iterate(hrefs, function (node) {
                node.addEventListener("click", exitGenericListener);
            });
        }

        function exitWarningImportContacts() {
            iterate(hrefs, function (node) {
                node.addEventListener("click", exitImportContactsListener);
            });
        }

        function removeExitImportContactsPrompt() {
            canClose = true;
            iterate(hrefs, function (node) {
                node.removeEventListener("click", exitImportContactsListener);
            });
        }

        let initializeSearch = () => {
            let searchNodes = flow === 'upload' ? nodes.uploadSearchField : nodes.searchField;

            const sf = initSearchField(searchNodes, function (value) {
                if (value) {
                    requestData.q = encodeURI(value);
                    requestData.page = 1;
                    getContacts({...params, ...requestData, sort: lastSort}).then(renderContacts);

                } else if (value.length === 0) {
                    requestData.q = "";
                    getContacts({...params, ...requestData, sort: lastSort}).then(renderContacts);
                }
            }, {next: requestData.q});

            sf.resetBtn.style.display = "none";
        }

        function applyPreSelectedFilters() {
            let filterSelectionData = document.querySelector(".contact-updates-wrap");
            // saved filters are present if returning to a saved campaign that had previously saved filters
            let savedFilters = filterSelectionData.getAttribute("data-used-filters");
            // current filters are the filters you are currently working with in this flow
            let currentFilters = filterSelectionData.getAttribute("data-current-filters");

            if ((!savedFilters || savedFilters === "") && (!currentFilters || currentFilters === "{}")) return;

            let filterSelection = currentFilters && Object.keys(JSON.parse(currentFilters)).length ? JSON.parse(currentFilters) : JSON.parse(savedFilters);

            if (filterSelection === null) return;

            let expiredFilters = [];

            Object.keys(filterSelection).forEach((key, i) => {
                let category = key;
                let filters = filterSelection[key];

                // accommodate for Boolean filters which are saved as true/false instead of arrays
                if (filters === true || filters === false) {
                    filters = [JSON.parse(filters)];
                }

                filters.forEach(filter => {
                    let filterElement = document.querySelector(`.filter-wrap[data-id="${category}"] .filter-options .option[data-id="${filter.id ? filter.id : encodeURIComponent(filter)}"]`);
                    toggleFilter(filterElement, category);
                })     

            })

            // display error indicating which filters have been removed from the campaign
            if (expiredFilters.length) {
                document.querySelector(".expired-filters").classList.remove("hide");
                let renderedFilters = expiredFilters.map(filter => `<div>${filter}</div>`).join('');
                document.querySelector(".expired-filters .filter-names").innerHTML = renderedFilters;
            }

            setTimeout(() => {
                document.querySelectorAll(".autocomplete_input_js").forEach(node => {
                    node.blur();
                })
            }, Object.keys(filterSelection).length * 40)
            
            window.filtersChanged = false;
        }

        let filterNameMapping = {
            contact_types: {
                plural: "Contact Types",
                singular: "Contact Type",
            },
            companies: {
                plural: "Companies",
                singular: "Company",
            },
            company_types: {
                plural: "Company Types",
                singular: "Company Type",
            },
            company_statuses: {
                plural: "Company Statuses",
                singular: "Company Status",
            },
            is_primary: {
                plural: "Primary Contacts",
                singular: "Primary Contact",
            },
            is_billing: {
                plural: "Billing Contacts",
                singular: "Billing Contact",
            },
            territories: {
                plural: "Territories",
                singular: "Territory",
            },
            agreement_types: {
                plural: "Agreement Types",
                singular: "Agreement Type",
            },
            marketing_groups: {
                plural: "Marketing Groups",
                singular: "Marketing Group",
            },
            classifications: {
                plural: "Classifications",
                singular: "Classification",
            },
            locations: {
                plural: "Locations",
                singular: "Location",
            },
            primaries: {
                plural: "Primaries",
                singular: "Primary",
            },
            titles: {
                plural: "Titles",
                singular: "Title",
            },            
        }

    
        // toggle the filter selection in dropdown
        let toggleFilter = (chosenFilterElement, categoryId, togglingPreset) => {
            if(!chosenFilterElement) return;
            
            let filterId = chosenFilterElement.getAttribute("data-id");
            let filterWrap = document.querySelector(`.filter-wrap[data-id='${categoryId}']`)
            let filterSelections = filterWrap.querySelector(".selections");
            let filterType = chosenFilterElement.getAttribute("data-type");

            if (chosenFilterElement.classList.contains("selected")) {
                deselectFilter(filterId, categoryId)
                return; 
            }               
        
            if (!params[categoryId] || !params[categoryId].length || togglingPreset) {
                // hide the 'all' selection if not already hidden
                filterSelections.querySelector(".selection.all").classList.add("hide");
            }

            // add filter selection to filter params
            let convertedFilterId = isNaN(filterId) ? decodeURIComponent(filterId) : parseInt(filterId);

            if(!togglingPreset) {
                if(filterType === "radio" || filterType === "boolean") { 
                    params[categoryId] = JSON.parse(filterId);
                    let dropdownSelection = filterWrap.querySelector(".option.selected");
                    let selectedChip = filterWrap.querySelector(".selection:not(.all)");
                    if(dropdownSelection) dropdownSelection.classList.remove("selected");
                    if(selectedChip) selectedChip.remove();
                    appliedFilters[categoryId] = [chosenFilterElement.innerText];
                } else {
                    params[categoryId].push(convertedFilterId);
                    appliedFilters[categoryId].push(chosenFilterElement.innerText);
                }
            }

            // add 'selected' state to filter option in dropdown
            chosenFilterElement.classList.add("selected");

            // create new filter chip
            let newSelectionElement = document.createElement("div");
            newSelectionElement.classList.add("selection");
            newSelectionElement.setAttribute("data-id", filterId)
            newSelectionElement.innerHTML = `
                <span class="filter-title">
                    ${chosenFilterElement.innerText}
                </span>
                <span class="remove">✕</div>
            `;

            // add deselect filter event listener
            newSelectionElement.addEventListener("click", (event) => {
                deselectFilter(filterId, categoryId)
            });

            // add new filter to selections
            filterSelections.prepend(newSelectionElement);

            window.filtersChanged = true;
        }

        // deselect filter chip
        let deselectFilter = (filterId, categoryId) => {
            let filterWrap = document.querySelector(`.filter-wrap[data-id='${categoryId}']`);
            let filterSelections = filterWrap.querySelector(".selections");
            let selectionElement = filterSelections.querySelector(`[data-id="${filterId}"]`);
            let selectionText = selectionElement.querySelector(".filter-title").innerText;
            let filterOptionElement = filterWrap.querySelector(`.filter-options .option[data-id="${filterId}"]`)
            let filterType = filterWrap.getAttribute("data-type");
            // deselect filter option in dropdown
            filterOptionElement.classList.remove("selected");
            // remove selection
            selectionElement.remove();

            if(filterType === "radio" || filterType === "boolean") {
                // set radio and boolean to default values if deselected
                params[categoryId] = filterData[categoryId].default;
                appliedFilters[categoryId] = [];
                filterSelections.querySelector(".selection.all").classList.remove("hide");
            } else {
                // remove filter selection from params
                let convertedFilterId = isNaN(filterId) ? decodeURIComponent(filterId) : parseInt(filterId);
                params[categoryId] = params[categoryId].filter(item => item !== convertedFilterId);
                appliedFilters[categoryId] = appliedFilters[categoryId].filter(item => item !== selectionText.trim());

                // show the 'all' selection if no other filters selected
                if (!params[categoryId].length) {
                    filterSelections.querySelector(".selection.all").classList.remove("hide");
                }
            }

            // re-activate filter option in dropdown
            filterWrap.querySelector(`.filter-options .option[data-id="${filterId}"]`).classList.remove("selected");
        }

        let closeAllSelectors = (currentId) => {
            let selectors = document.querySelectorAll(".filter-wrap .selector.active");
    
            selectors.forEach(selector => {
                if(currentId) {
                    // exclude current selector if required
                    if(selector.getAttribute("data-id") !== currentId) {
                        selector.classList.remove("active");
                    }
                } else {
                    selector.classList.remove("active");
                }
            })
        }

        let clearSearch = (categoryId) => {
            let search = document.querySelector(`.filter-wrap .selector[data-id="${categoryId}"] .filter-search`);
            if(!search) return;
            
            search.value = '';
    
            //simulate input event for search to trigger event listener
            let event = document.createEvent('Event');
            event.initEvent('input', true, true);
            search.dispatchEvent(event);
        }

        let filterEventListeners = () => {
            let allSelectors = document.querySelectorAll(".filter-wrap .selector");
            let limitSelectors = document.querySelectorAll(".limit-contacts .mini-toggle input");
            
            allSelectors.forEach(selector => {
                let categoryId = selector.getAttribute("data-id");
                let search = selector.querySelector(".filter-search");
    
                selector.querySelector(".filter-name").addEventListener("click", () => {
                    closeAllSelectors(categoryId);
                    if(selector.classList.contains("active")) {
                        selector.classList.remove("active");
                    }else {
                        clearSearch(categoryId);
                        selector.classList.add("active");
                    }
                })
    
                let options = selector.querySelectorAll(".filter-options .option");
    
                options.forEach(option => {
                    option.addEventListener("click", () => {
                        toggleFilter(option, categoryId);
                    })
                })
    
                // add filter search
                if(search) {
                    search.addEventListener("input", (event) => {   
                        let results = false;               
                        
                        options.forEach(option => {
                            let match = option.innerText.toLowerCase().indexOf(event.target.value.toLowerCase());
                            if(match > -1) {
                                option.classList.remove("hide");
                                results = true;
                            } else {
                                option.classList.add("hide");
                            }
                        })
    
                        let noResults = selector.querySelector(".no-results");
                        results ? noResults.classList.add("hide") : noResults.classList.remove("hide");
                    })
                };
            })

            limitSelectors.forEach(selector => {
                selector.addEventListener("change", (event) => {
                    let field = event.currentTarget.getAttribute("data-field");

                    if(event.target.checked) {
                        appliedFilters[field] = ["Yes"];
                        params[field] = true;
                    } else {
                        appliedFilters[field] = []
                        params[field] = [];
                    }
                })
            })
    
            nodes.importContactsContent.addEventListener("click", (event) => {
                if(!event.target.classList.contains('selector') && !event.target.classList.contains('filter-name') && !event.target.classList.contains('filter-search')) {
                    closeAllSelectors();
                }
            })            
        }

        let renderFilters = (errors) => {
            let output = '';
            
            // iterate through filterNameMapping to determine correct order of filters
            iterate(filterNameMapping, (value, key) => {
                // only render filters that have been returned with data
                let optionList = (filterData[key] && filterData[key].filters) ? filterData[key].filters : filterData[key];

                if(!optionList) return;

                params[key] = [];
                appliedFilters[key] = [];

                let filterOptions = optionList.map(option => { 
                    let name = "";
                    let id = "";
                    
                    if(option && option.name) {
                        name = utilities.sanitizeData(option.name);
                    } else if(option) {
                        name = utilities.sanitizeData(option);
                    }

                    // company_types sends 'id' and 'name', but only accepts 'name' 
                    // so this is a special case for it
                    if(key === "company_types") {
                        id = encodeURIComponent(option.name);
                    // otherwise send 'id' if it exists
                    } else if(option && option.id) {
                        id = option.id;
                    // or just the 'name' if no 'id'
                    } else if(option) {
                        id = encodeURIComponent(option);
                    }
                    
                    // We have to encode filter names when storing them as data  
                    // attributes, so they don't get converted to HTML in rare cases.
                    // Then we decode them when adding the data to the filter params.
                    return `<div class="option" data-id="${id}" data-type="${filterData[key].type || ''}">${name}</div>`
                }).join('')

                let search = `
                    <div class="search-wrap">
                    <input class='filter-search' type="text" placeholder="Search ${filterNameMapping[key].plural}">
                </div>`;

                let disabledClass = errors && errors.indexOf(key) > -1 ? "disabled" : "";

                let error = errors && errors.indexOf(key) > -1 ? `
                    <p class="filter-error">
                    Error fetching <strong>${filterNameMapping[key].plural}</strong>. <br>
                    Please provide required <a href='/platform' target="_blank">API permissions</a>.
                    </p>` : '';

                output += `
                    <div class="filter-wrap" data-type="${filterData[key].type || ''}" data-id="${key}">
                        <div class="inner-wrap ${disabledClass}">
                            <div class="selector" data-id="${key}">
                                <div class="filter-name">
                                    ${filterNameMapping[key].singular}
                                </div>
                                <div class="filter-options">
                                    ${search}
                                    <div class="options-wrap">
                                        ${filterOptions}
                                    </div>
                                    <p class="no-results hide">No results found</p>
                                </div>
                            </div>
                            <div class="selections"><div class="selection all">All ${filterNameMapping[key].plural}</div></div>
                        </div>
                        ${error}
                    </div>
                `             
            })
    
            nodes.contactFilters.innerHTML = output;
    
            filterEventListeners();
            // showPreservedFilters(); TO DO - reinable and fix this function    
            filtersRendered = true;
        }

        function fetchFilters(){
            // upon entering import contacts sub-flow:
            nodes.loader.classList.remove("disabled");

            requestFilters().then((data) => {
                filterData = data.filters;

                setTimeout(()=>{
                    exitWarningImportContacts();
                    initializeSearch();
                    renderFilters(data.errors);
                    start(filters, "import");
                }, 500);

                setTimeout(() => {
                    applyPreSelectedFilters();
                    nodes.loader.classList.add("disabled");
                }, 1000)

            }).catch(error => {

                // show different messaging for 424 response
                modalTemplate = filterResponseStatus === 424 ? nodes.modal500Error : nodes.modalApiPermissions;
                nodes.loader.classList.add("disabled");

                createdModal.open(null, function (el) {
                    el.querySelector(".error-confirm_js").addEventListener("click", () => {
                        createdModal.close();
                        importContactsSideBar.close();
                    });
                }, modalTemplate);
            });

            createResponseTable();
        }

        resetUploadContactsCSV = () => {
            // reset upload form each time they re-enter the flow
            nodes.uploadContactsForm.uploadForm.get(0).reset();
            nodes.uploadContactsForm.fileStatus.innerText = "No file selected";
            nodes.uploadContactsForm.proceedButton.classList.add("disabled");
            nodes.uploadContactsForm.statusIcon.classList.remove("cross-svg")
            nodes.uploadContactsForm.statusIcon.classList.remove("checkmark-svg")
        }

        uploadContactsCSV = () => {
            let fileName;

            document.querySelector("#uploadFile").addEventListener("change", (e) => {
                fileName = utilities.sanitizeData(e.target.value.split("\\").pop());

                if(fileName.length) {
                    nodes.uploadContactsForm.fileStatus.innerText = fileName;
                    $(".upload-wrap form").submit();
                } else {
                    nodes.uploadContactsForm.fileStatus.innerText = "No file selected";
                }
            })

            $(".upload-wrap form").submit(function(e) {

                e.preventDefault();

                let form = $(this);

                let url = form.attr('action');
                let formData = new FormData(form[0]);                

                nodes.uploadContactsForm.spinner.classList.add('show');

                $.ajax({
                    type: "POST",
                    url: url,
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function(data)
                    {
                        nodes.uploadContactsForm.spinner.classList.remove('show');
                        var response = $($.parseHTML(data));
                        var error = response.find("ul.errorlist").find("li")[0];

                        platform = nodes.contactsWrapper.getAttribute("data-platform");

                        csvFileName = fileName;

                        if(response.find("input[name='flow-type']").val() === "None") {
                            platform = 'csv-random';
                        }

                        if(error && error.innerText) {
                            nodes.uploadContactsForm.formMessage.innerText = error.innerText;
                            nodes.uploadContactsForm.formMessage.classList.add("error");
                            nodes.uploadContactsForm.proceedButton.classList.add("disabled");
                            nodes.uploadContactsForm.statusIcon.classList.add("cross-svg")
                            nodes.uploadContactsForm.statusIcon.classList.remove("checkmark-svg")
                            // clear file so the user can try uploading again
                            document.querySelector("#uploadFile").value = ''

                        } else {
                            nodes.uploadContactsForm.formMessage.innerText = ""
                            nodes.uploadContactsForm.formMessage.classList.remove("error");
                            nodes.uploadContactsForm.proceedButton.classList.remove("disabled");
                            nodes.uploadContactsForm.statusIcon.classList.add("checkmark-svg")
                            nodes.uploadContactsForm.statusIcon.classList.remove("cross-svg")
                        }
                    }
                });
            });
        }
        
        getUploadedContacts = () => {
            flow = "upload";

            // show loading screen
            nodes.loader.classList.remove("disabled");

            createResponseTable();

            params.sort = {"company":"asc"};
            getContacts(params,true).then((result) => {

                let contactsStore = {};
                numberOfContacts = result.page_info.available_ids.length;

                result.page_info.count = numberOfContacts;

                result.page_info.available_ids.forEach( (i) => {
                    contactsStore[i] = true;
                });

                localStorage.setItem("nps-contacts-session-storage", JSON.stringify(contactsStore));

                renderContacts(result);
                uploadContactsEvents();
                initializeSearch();

                nodes.loader.classList.add("disabled");
                waitTR.forEach(el => el.classList.add("disabled"));
            });
        }

        importContactsEvents = () => {
            //import contacts
            if(nodes.confirmPermission) {
                nodes.confirmPermission.addEventListener("click", () => {
                    flow = "import";
                    fetchFilters();
                    importContactsSideBar.switch("selectFilters", 1);
                });
                nodes.importContactsBtn.addEventListener("click", () => {
                    platform = nodes.contactsWrapper.getAttribute("data-platform");
                    importContactsSideBar.switch(firstSidebar[0], firstSidebar[1]);
                });
            } else {
                nodes.importContactsBtn.addEventListener("click", () => {
                    flow = "import";
                    platform = nodes.contactsWrapper.getAttribute("data-platform");
                    fetchFilters();
                    importContactsSideBar.switch(firstSidebar[0], firstSidebar[1]);
                })
            }

            reviewRecipientsStep.querySelector(".contacts-back_js").addEventListener("click", () => {
                importContactsSideBar.switch("selectFilters", 1);
            });
        }

        uploadContactsEvents = () => {
            reviewRecipientsStep.querySelector(".upload-contacts-back_js").addEventListener("click", () => {
                uploadContactsSideBar.switch("uploadContacts", 1);
            });
        }

        return {

            init: function () {

                onExitGeneric();
                importContactsEvents();

                if(nodes.uploadContactsBtn){
                    uploadContactsCSV();

                    nodes.doneUpload.addEventListener("click", () => {
                        flow = "upload"
                        submitCampaign();
                    })
            
                    nodes.uploadContactsBtn.addEventListener("click", () => {
                        resetUploadContactsCSV();
                        uploadContactsSideBar.switch("uploadContacts", 1);
                    });
                }

                if(nodes.confirmUpload){
                    nodes.confirmUpload.addEventListener("click", () => {
                        getUploadedContacts();
                        uploadContactsSideBar.switch("reviewUploadRecipients", 1)
                    })
                }

                // remove steps and display specific messaging if entering this part of the flow from the campaign manager
                if(campaignIsLocked) {
                    document.querySelector(".nps-stepper").remove();
                    let copyWrap = document.querySelector(".review-contacts-wrap");
                    copyWrap.querySelector("h1").innerText = "Review and edit contacts"
                    copyWrap.querySelector("p").innerHTML = "You can edit your contacts below and select <strong>Update Campaign</strong> to save changes."
                    document.querySelector(".return-to-manager").classList.remove("hide");    

                    let textWrapper = document.querySelector(".nps-contacts__header");
                    textWrapper.querySelectorAll("p").forEach(node => node.innerHTML = "");

                    let platformName = "ConnectWise PSA";
                    if(platform === "zd") platformName = "Zendesk";
                    if(platform === "fd") platformName = "Freshdesk";
                    if(platform === "ks") platformName = "Kaseya BMS";
                    if(platform === "at") platformName = "Autotask PSA";
                    
                    let contactSource = nodes.contactUpdatesWrap.getAttribute("data-csv-name") === '' ? "import" : "upload";
                    let otherMethod = contactSource === "import" ? 'upload contacts via CSV' : `import contacts via ${platformName}`

                    let newCopy = `
                        <strong>Note:</strong> Your contact source is now locked to the 
                        "${contactSource}" flow. If you wish to ${otherMethod}, 
                        you must create a new campaign`;

                    textWrapper.querySelector("p").innerHTML = newCopy;
                    
                    if(contactSource === "import") {
                        // contact source is tss import - remove csv upload button
                        nodes.uploadContactsBtn.remove();
                    } else {
                        // contact source is csv import - remove import button
                        nodes.importContactsBtn.remove();
                    }

                    let contentWrapper = document.querySelector(".send-survey-wrap");
                    let returnButton = `<a href="#" class="button-tertiary previous back-to-start">Back</a>`

                    contentWrapper.insertAdjacentHTML('beforeend', returnButton);

                    contentWrapper.querySelector(".back-to-start").addEventListener("click", () => {
                        nodes.addRecipientsWrap.classList.add("disabled");
                        nodes.reviewContactsWrap.classList.remove("disabled");   

                        window.scrollTo(0,0);

                        importContactsSideBar.close();
                        if(uploadContactsSideBar)
                            uploadContactsSideBar.close();
                    })

                }

                nodes.editBtn.addEventListener("click", () => {
                    nodes.addRecipientsWrap.classList.remove("disabled");
                    nodes.reviewContactsWrap.classList.add("disabled");
                });  
            }
        }
    }
);
